module.exports = __webpack_public_path__ + "static/business-team-with-hands-on-top-at-office-PTCEYXU-950ba9b289232c5dc902241b25fbfde4.jpg";